import { faCircleInfoRegular, FaIcon } from '@/lib/fa'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const DriverGroupInfoBox = () => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-start tw-gap-2 tw-bg-gray-100 tw-px-2 tw-py-3">
      <FaIcon icon={faCircleInfoRegular} />
      <p className="tw-text-xs tw-text-content-base/80">
        {t('driverModule.confirm-activation-info')}
      </p>
    </div>
  )
}

export default DriverGroupInfoBox
